var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/address.ts
import { A } from "@adornis/base/env-info.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
var ZipCity = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
};
ZipCity._class = "ZipCity";
__decorateClass([
  Field((type) => String)
], ZipCity.prototype, "zip", 2);
__decorateClass([
  Field((type) => String)
], ZipCity.prototype, "city", 2);
ZipCity = __decorateClass([
  Entity()
], ZipCity);
var Address = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
  static resolveID(entity) {
    return entity._id ??= A.getGloballyUniqueID();
  }
  toString() {
    const zipCity = this.zipCity?.city && this.zipCity?.zip ? `${this.zipCity.zip} ${this.zipCity.city}` : "";
    const street = this.streetAndHousenumber ? zipCity ? this.streetAndHousenumber + ", " : this.streetAndHousenumber : "";
    const additional = this.additionalInfo ? street ? this.additionalInfo + ", " : this.additionalInfo : "";
    return additional + street + zipCity;
  }
};
Address._class = "Address";
__decorateClass([
  Field((type) => String)
], Address.prototype, "name", 2);
__decorateClass([
  Field((type) => String)
], Address.prototype, "streetAndHousenumber", 2);
__decorateClass([
  Field((type) => ZipCity, { default: (v) => v ?? new ZipCity({}) })
], Address.prototype, "zipCity", 2);
__decorateClass([
  Field((type) => String)
], Address.prototype, "bundesland", 2);
__decorateClass([
  Field((type) => String)
], Address.prototype, "country", 2);
__decorateClass([
  Field((type) => String)
], Address.prototype, "additionalInfo", 2);
__decorateClass([
  Field((type) => String, { default: (v) => v ?? A.getGloballyUniqueID() })
], Address.prototype, "_id", 2);
Address = __decorateClass([
  Entity()
], Address);
export {
  Address,
  ZipCity
};
